export default {"src":"/_next/static/media/Content-4.db275d0f.svg","height":455,"width":700};